import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserSupportModule } from '@libraries/browser-support';
import { ComponentLibraryModule } from '@libraries/component-library';
import { DatadogModule } from '@libraries/datadog';
import { FaIconModule } from '@libraries/fa';
import { FeatureFlagsModule } from '@libraries/feature-flags';
import { GoogleAnalyticsModule } from '@libraries/google-analytics';
import { GoogleMapsAddressModule } from '@libraries/google-maps';
import { HotjarModule } from '@libraries/hotjar';
import { SentryModule } from '@libraries/sentry';
import { SharedEnvModule } from '@libraries/shared-env';
import { TranslocoRootModule } from '@libraries/transloco-root';
import { UiModule } from '@libraries/ui';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CookieService } from 'ngx-cookie-service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { environment } from '../environments/environment';
import { AppEffects, reducers } from './+state';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CanNavigateGuard } from './guards/can-navigate.guard';
import { HeaderWrapperComponent } from './header-wrapper/header-wrapper.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LoginComponent } from './login/login.component';
import { PropertyIsEligibleComponent } from './property-is-eligible/property-is-eligible.component';
import { PropertyNotEligibleComponent } from './property-not-eligible/property-not-eligible.component';

@NgModule({
  declarations: [
    PropertyNotEligibleComponent,
    PropertyIsEligibleComponent,
    AppComponent,
    LandingPageComponent,
    LoginComponent,
    HeaderWrapperComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    BrowserSupportModule,
    ComponentLibraryModule,
    DatadogModule.forRoot({
      env: environment.envName,
      clientToken: environment.datadog.clientToken,
      applicationId: environment.datadog.applicationId,
      service: environment.appName,
    }),
    EffectsModule.forRoot([AppEffects]),
    FaIconModule,
    FeatureFlagsModule,
    FormsModule,
    GoogleMapsAddressModule.forRoot({
      apiKey: environment.gmapsApiKey,
      libraries: ['places'],
    }),
    HotjarModule.forRoot({ siteId: environment.hotjarSiteId }),
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSnackBarModule,
    MatTooltipModule,
    ReactiveFormsModule,
    SentryModule.forRoot({
      environment: environment.envName,
      dsn: environment.sentryDsn,
    }),
    SharedEnvModule.forRoot(environment),
    StoreModule.forRoot(reducers),
    StoreRouterConnectingModule.forRoot(),
    TranslocoRootModule,
    UiModule,
    // Below modules need to be included last because they depend on above StoreModule
    GoogleAnalyticsModule.forRoot({
      trackingId: environment.googleAnalyticsTrackingId,
    }),
    !environment.production || environment.envName === 'acceptance'
      ? StoreDevtoolsModule.instrument({
          maxAge: 25,
          connectInZone: true,
        })
      : [],
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  providers: [
    CookieService,
    CanNavigateGuard,
    provideNgxMask(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
